import { render, staticRenderFns } from "./BeamView.vue?vue&type=template&id=0c1ae6d8&scoped=true"
import script from "./BeamView.vue?vue&type=script&lang=js"
export * from "./BeamView.vue?vue&type=script&lang=js"
import style0 from "./BeamView.vue?vue&type=style&index=0&id=0c1ae6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1ae6d8",
  null
  
)

export default component.exports